import { c as _c } from "react/compiler-runtime";
import { format, isSameDay } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
;
import Button from 'src/components/button/Button';
import CalendarSvg from 'src/components/svg/CalendarSvg';
import { useProgramDatesContext } from "src/lib/contexts/ContextTypes";
import classNames from 'classnames';
import styles from './NoShows.module.css';
import { locale as loc } from "@locale";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import ResetFilter from "src/components/program/ResetFilter";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type NoShowsProps = {
  className?: string;
  numFilteredMovies?: number;
  numFilteredShows?: number;
};
//#endregion

//#region [Component]
export default function NoShows(t0) {
  const $ = _c(30);
  const {
    className,
    numFilteredMovies,
    numFilteredShows
  } = t0;
  const datesContext = useProgramDatesContext();
  let content;
  let showNextShowDate = false;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== className || $[1] !== content || $[2] !== datesContext || $[3] !== showNextShowDate) {
    let nextShowDate;
    if ((datesContext?.availableDates?.length ?? 0) > 0) {
      showNextShowDate = BRAND === "kinodk" ? false : true;
      let t5;
      if ($[10] !== datesContext.selectedDate) {
        t5 = d => isSameDay(d, datesContext.selectedDate);
        $[10] = datesContext.selectedDate;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      nextShowDate = datesContext.availableDates.find(t5);
      if (datesContext.selectedDate && !nextShowDate) {
        let t6;
        if ($[12] !== datesContext.selectedDate) {
          t6 = format(datesContext.selectedDate, "d. MMMM", {
            locale
          });
          $[12] = datesContext.selectedDate;
          $[13] = t6;
        } else {
          t6 = $[13];
        }
        let t7;
        if ($[14] !== t6) {
          t7 = <>Ingen forestillinger for {t6}</>;
          $[14] = t6;
          $[15] = t7;
        } else {
          t7 = $[15];
        }
        content = t7;
      }
    } else {
      let t5;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <>{loc.program.noShows.noMoreShowsForLocation}</>;
        $[16] = t5;
      } else {
        t5 = $[16];
      }
      content = t5;
    }
    if ($[17] !== className) {
      const themeStyles = getThemeStyles(styles);
      t4 = classNames(styles.NoShows, className, themeStyles);
      $[17] = className;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t1 = styles.Text;
    t2 = content;
    t3 = showNextShowDate && !!nextShowDate && <div>{loc.program.noShows.nextShowday} <Button className={styles.DateSelectorButton} text={format(new Date(nextShowDate), "iiii d. MMMM", {
        locale
      })} onClick={() => datesContext.setSelectedDate(datesContext.availableDates[0])} icon={<CalendarSvg className={styles.CalendarSvg} />} inverse={true} /></div>;
    $[0] = className;
    $[1] = content;
    $[2] = datesContext;
    $[3] = showNextShowDate;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = showNextShowDate;
    $[9] = content;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    showNextShowDate = $[8];
    content = $[9];
  }
  let t5;
  if ($[19] !== numFilteredMovies || $[20] !== numFilteredShows) {
    t5 = BRAND === "kinodk" && <ResetFilter numFilteredMovies={numFilteredMovies} numFilteredShows={numFilteredShows} />;
    $[19] = numFilteredMovies;
    $[20] = numFilteredShows;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t4 || $[28] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[27] = t4;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}
//#endregion